// UI-safe notices when deterministic fallbacks substitute for provider output.
import type { ProviderKind } from '../prompts/types.js';

export const FALLBACK_NOTICE =
  'Local fallback used — suggestions are deterministic placeholders, not AI-generated.';

export const KEY_REQUIRED_NOTICE =
  'AI completion requires an API key. Configure DeepSeek or Gemini in Setup.';

export function fallbackNoticeForProvider(_provider: ProviderKind | 'local'): string {
  return `${FALLBACK_NOTICE} ${KEY_REQUIRED_NOTICE}`;
}
